export const APP_ENV = process.env.NODE_ENV;
export const API_HOST = process.env.REACT_APP_API_HOST || "/api";
export const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST || "/socket.io";
export const ACCEPTABLE_RESPONSE = process.env.REACT_APP_ACCEPTABLE_RESPONSE || "JSON";
export const USER_LOCALE = process.env.REACT_APP_USER_LOCALE || "es_locale";
